// extracted by mini-css-extract-plugin
export var addressFields = "_ms-1";
export var grow = "_ms-2";
export var modalFooter = "_ms-0";